import { setSpecificMessage, url } from "valibot";
setSpecificMessage(
  url,
  (issue) => `URL invalide: reçu ${issue.received}`,
  "fr"
);